import React from 'react'
import { useOutletContext } from "react-router-dom";
import MeetingTranscriptChatInterface from '../components/chat/MeetingTranscriptChatInterface';

function MeetingTranscript() {
 const { isMobile, sidebarOpen, meetingTranscriptionChats, setMeetingTranscriptionChats } = useOutletContext();

  return (
    <MeetingTranscriptChatInterface
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setChats={setMeetingTranscriptionChats}
      chats={meetingTranscriptionChats}
    />
  );
}

export default MeetingTranscript

